import { TaskDefinition } from 'modules/inbox_tasks/lib/abstraction'

export const PolicyAcknowledgementTaskDefinition: TaskDefinition<'HandbookPagesPage'> = {
  taskableTypename: 'HandbookPagesPage',
  getUrl: ({ info, navigation }) => {
    if (!info.id) return null

    return navigation.pages.page.fullPath({
      pageId: info.id,
    })
  },
  getTitle: ({ info }) => {
    return info.title ?? ''
  },
}
